import { translate } from '../../../../localization';
import styles from './EmptyTab.styles.module.css';

export default function EmptyTab() {
  return (
    <div className={styles['brands-info__empty_tab']}>
      <div className={styles['brands-info__empty_tab_header']}>
        {translate('empty_brand_page_text')}
      </div>

      <div className={styles['brands-info__empty_tab_description']}>
        {translate('empty_brand_page_subtext')}
      </div>
    </div>
  );
}
